import { en } from './_en';
import { es } from './_es';

import { createTranslationsHook } from '~/shared/i18n/createTranslationsHook';

export const useTranslations = createTranslationsHook({ en, es });

export type DefaultTranslations = typeof en;
